"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reversedLanguageCodes = exports.languageCodes = void 0;
exports.languageCodes = {
    en: 'en',
    es: 'es',
    br: 'pt-br',
    fr: 'fr',
    de: 'de',
};
exports.reversedLanguageCodes = {
    [exports.languageCodes.en]: 'en',
    [exports.languageCodes.es]: 'es',
    [exports.languageCodes.br]: 'pt',
    [exports.languageCodes.fr]: 'fr',
    [exports.languageCodes.de]: 'de',
};
